import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";
import { checkNullStr, filterActiveData } from "../../_helpers/utilities";
import { addRec, fetchListing, getById } from "../../services";
import Pagination from "../CustomPagination";
import { Loader } from '../Loader';
import SearchableSelect from "../Master/searchableSelect";

const SelectCustomerModal = ({
    openModalFunc,
    openModal,
    closeModal,
    selectedUser,
    labelVal = "Select Customer",
    isEmployeerWise = true,
    employeeBranchOnly = true,
    disabled
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isDirty },
        setValue,
        getValues,
        control,
        reset,
        clearErrors,
        watch,
        setError,
        ...rest
    } = useForm({
        name: "",
        sapNo: "",
        masterBranchId: "",
        masterDispatchPlantId: "",
        seedingCustomerTypeValue: "",
    });

    const { seedingData, PageSize } = useSelector((state) => state.common);

    const [customerListArrVal, setCustomerListArrVal] = useState([]);
    const [customerKeyArrVal, setCustomerKeyArrVal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [PerPage, setPerPage] = useState(PageSize);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(1);
    const [TotalItems, setTotalItems] = useState(0);
    // const [customerArr, setCustomerArr] = useState([]);

    // const CustomerList = async () => {
    //     let data = await fetchListing("/MasterCustomer/getalls");
    //     if (data?.status === 200) {
    //         if (data?.data?.length > 0) {
    //             let customerType = data?.data?.map((item) => ({
    //                 ...item,
    //                 name: item?.name,
    //             }));
    //             setCustomerArr(filterActiveData(customerType));
    //         }
    //     }
    // };

    const [branchArr, setBranchArr] = useState([]);

    const branchList = async () => {
        let data = await getById(`/MasterBranch/getalls?isEmployeerWise=${isEmployeerWise}&employeeBranchOnly=${employeeBranchOnly}`);
        if (data?.status === 200) {
            if (data?.data?.length > 0) {
                setBranchArr(filterActiveData(data?.data));
            } else {
                setBranchArr([]);
            }
        }
    };
    const [plant, setPlant] = useState([]);

    const PlantList = async () => {
        let data = await fetchListing("/MasterPlant/getalls");
        if (data?.status === 200) {
            if (data?.data?.length > 0) {
                let addName = data?.data.map((item) => {
                    let sapcode = item?.sapCode ? " (" + item?.sapCode + ")" : "";
                    return ({ ...item, name: item.name + sapcode })
                });
                setPlant(addName);
            }
        }
    };

    useEffect(() => {
        if (openModal) {
            // CustomerList();
            branchList();
            PlantList();
        }
    }, [openModal]);

    const onSubmit = async (data, CurrentPage, PerPage) => {
        setLoading(true)
        data.isEmployeerWise = isEmployeerWise
        data.employeeBranchOnly = employeeBranchOnly
        let result = await addRec(`/MasterCustomer/GetByFilterPagination?PageNumber=${CurrentPage}&PageSize=${PerPage}`, data);
        if (result?.status === 200) {
            if (result?.data?.items?.length > 0) {
                setCustomerListArrVal(result.data.items);
                setTotalPage(result.data.totalPages)
                setTotalItems(result.data.totalItems)
            } else {
                setCustomerListArrVal([]);
            }
        } else {
            setCustomerListArrVal([]);
        }
        setLoading(false)
    };


    const PerPageSizeChangeFunc = (perPage) => {
        let OldVal = PerPage
        if (OldVal !== parseInt(perPage)) {
            setPerPage(parseInt(perPage))
            setCurrentPage(1)
            onSubmit(getValues(), 1, parseInt(perPage))
        }
    }

    const PaginationPageChange = (PageNum) => {
        let OldVal = CurrentPage
        if (OldVal !== PageNum) {
            setCurrentPage(PageNum)
            onSubmit(getValues(), PageNum, PerPage)
        }
    }
    const resetDefault = () => {
        reset(item => ({
            ...item,
            name: "",
            sapNo: "",
            masterBranchId: null,
            masterDispatchPlantId: null,
            seedingCustomerTypeValue: "",
        }))
    }

    return (
        <>
            <p onClick={() => openModalFunc()} className='btn_diaaebled select_custo' disabled={disabled}>
                <label className="cu_form_label">{labelVal}<i class="far fa-long-arrow-right ms-2"></i></label>
            </p>


            <Modal size="lg" show={openModal} onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Customer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="comanbox_body">
                        <div className="row mx-0">
                            <div className="col-2">
                                <div className="input-group mb-0">
                                    <input
                                        type="number"
                                        id="sapNo"
                                        name="sapNo"
                                        placeholder={errors.sapNo ? errors.sapNo.message : "Enter Sap No"}
                                        className={errors.inputVal ? "error" : ""}
                                        {...register("sapNo")}
                                    />
                                </div>
                            </div>
                            <div className="col-2">
                                {/* <SearchableSelect
                                    placeholder="Select Customer"
                                    name="name"
                                    //   optionList={customerKeyArrVal}
                                    optionList={customerArr}
                                    errors={errors.name}
                                    control={control}
                                    {...register("name")}
                                /> */}
                                <div class="input-group">
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder={errors.name ? errors.name.message : "Enter Name"}
                                        className={errors.name ? "error" : ""}
                                        {...register("name")}
                                    />
                                </div>
                            </div>
                            <div className="col-2">
                                <SearchableSelect
                                    placeholder="Select Branch"
                                    name="masterBranchId"
                                    optionList={branchArr}
                                    errors={errors.masterBranchId}
                                    control={control}
                                    {...register("masterBranchId")}
                                />
                            </div>
                            <div className="col-2">
                                <SearchableSelect
                                    placeholder="Select plant"
                                    name="masterDispatchPlantId"
                                    optionList={plant}
                                    errors={errors.masterDispatchPlantId}
                                    control={control}
                                    {...register("masterDispatchPlantId")}
                                />
                            </div>
                            <div className="col-2">
                                <SearchableSelect
                                    placeholder="Select Type"
                                    name="seedingCustomerTypeValue"
                                    optionList={seedingData?.seedingCustomerTypeList}
                                    errors={errors.seedingCustomerTypeValue}
                                    control={control}
                                    {...register("seedingCustomerTypeValue")}
                                />
                            </div>
                            {/* <div className="col-3">
                                <SearchableSelect
                                    placeholder="Select Region"
                                    name="regionVal"
                                    optionList={regionArr}
                                    errors={errors.regionVal}
                                    control={control}
                                    {...register("regionVal")}
                                />
                            </div> */}
                            <div className="col-1" >
                                <button class="BlackBtn modal_black" onClick={handleSubmit(async (data) => await onSubmit(data, CurrentPage, PerPage))}>Search</button>
                            </div>
                            <div className="col-1" >
                                <button class="BlackBtn modal_black" onClick={() => resetDefault()}>Reset</button>
                            </div>

                            <div className="select_custome">
                                <Tooltip
                                    place="bottom"
                                    className="tool_tip_graph"
                                    anchorId={"address"}
                                />
                                <table class="table addField_table mt-3">
                                    <thead>
                                        <tr>
                                            <th scope="col">SAP No</th>
                                            <th scope="col">Customer</th>
                                            <th scope="col">Branch</th>
                                            <th scope="col">Plant</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Action</th>
                                            {/* <th scope="col"></th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading
                                            ? <Loader />
                                            : customerListArrVal?.map((row, index) => {
                                                return (
                                                    <tr>
                                                        <td>{row?.sapNo}</td>
                                                        <td>
                                                            <Tooltip
                                                                place="bottom"
                                                                className="tool_tip_graph"
                                                                anchorId={index + "name"}
                                                            />
                                                            <span
                                                                className="table_icon"
                                                                id={index + "name"}
                                                                data-tooltip-content={checkNullStr(row?.billingAddress) + " , " + checkNullStr(row?.address2)}
                                                            >
                                                                {row?.name}
                                                            </span>
                                                        </td>
                                                        <td>{row?.masterBranch}</td>
                                                        <td>{row?.dispatchPlant}</td>
                                                        <td>{row?.seedingCustomerTypeValue}</td>
                                                        <td>
                                                            <button
                                                                onClick={() => selectedUser(row)}
                                                                className="Comnbtn OutlineRedBtn btn-cusm"
                                                            >
                                                                Select
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {customerListArrVal.length > 0 &&
                        <Pagination
                            PerPageSizeChangeFunc={(perPage) => PerPageSizeChangeFunc(perPage)}
                            PaginationPageChange={(pageNum) => PaginationPageChange(pageNum)}
                            TotalPage={TotalPage}
                            CurrentPage={CurrentPage}
                            TotalItems={TotalItems}
                            PerPage={PerPage}

                        />}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default SelectCustomerModal;